import { useState, useEffect } from 'react';
import axios from 'axios';
import { BookOpen, Search } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function KnowledgeBase() {
  const [articles, setArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, [searchTerm]);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams({
        published_only: 'true',
        ...(searchTerm && { search: searchTerm })
      });

      const response = await axios.get(
        `${API_BASE}/dialer/knowledge-base?${params}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setArticles(response.data);
    } catch (error) {
      console.error('Error fetching articles:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchArticle = async (articleId) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/knowledge-base/${articleId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSelectedArticle(response.data);
    } catch (error) {
      console.error('Error fetching article:', error);
    }
  };

  if (selectedArticle) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <button
          onClick={() => setSelectedArticle(null)}
          className="mb-4 text-blue-600 hover:text-blue-700"
        >
          ← Back to articles
        </button>
        <h2 className="text-2xl font-bold mb-4">{selectedArticle.title}</h2>
        <div className="prose max-w-none whitespace-pre-wrap">
          {selectedArticle.content}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-xl font-semibold flex items-center gap-2">
          <BookOpen className="w-6 h-6" />
          Knowledge Base
        </h3>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search articles..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full border rounded pl-10 pr-4 py-2"
        />
      </div>

      {loading ? (
        <div className="text-center py-8">Loading articles...</div>
      ) : articles.length === 0 ? (
        <div className="text-center py-8 text-gray-500">No articles found</div>
      ) : (
        <div className="space-y-2">
          {articles.map((article) => (
            <div
              key={article.id}
              onClick={() => fetchArticle(article.id)}
              className="border rounded p-4 hover:bg-gray-50 cursor-pointer"
            >
              <h4 className="font-semibold">{article.title}</h4>
              <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                {article.content.substring(0, 150)}...
              </p>
              {article.category && (
                <span className="inline-block mt-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                  {article.category}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


